import React from 'react';

export default ({ value, className }) => {
	const html = {__html: value || '<span/>'};
	return <div className={className} dangerouslySetInnerHTML={html}/>;
};
